'use client';

import { useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useStore } from '@/store/store';
import { apiAddFavoriteGame, apiRemoveFavoriteGame } from '@/lib/favorite-games';

export const useFavoriteGames = () => {
    // Use useShallow to properly handle object selector with shallow comparison
    const { favoriteGames, setFavoriteGames } = useStore(
        useShallow((state) => ({
            favoriteGames: state.userContext.favoriteGames,
            setFavoriteGames: state.userContext.setFavoriteGames
        }))
    );

    const addFavoriteGame = useCallback(
        async (gameId: string) => {
            setFavoriteGames((prev) => {
                if (prev.includes(gameId)) {
                    return prev;
                }
                return [...prev, gameId];
            });

            const apiSuccess = await apiAddFavoriteGame(gameId);

            if (!apiSuccess) {
                setFavoriteGames((prev) => prev.filter((id) => id !== gameId));
            }

            return apiSuccess;
        },
        [setFavoriteGames]
    );

    const removeFavoriteGame = useCallback(
        async (gameId: string) => {
            setFavoriteGames((prev) => prev.filter((id) => id !== gameId));

            const apiSuccess = await apiRemoveFavoriteGame(gameId);

            if (!apiSuccess) {
                setFavoriteGames((prev) => [...prev, gameId]);
            }

            return apiSuccess;
        },
        [setFavoriteGames]
    );

    return { favoriteGames, addFavoriteGame, removeFavoriteGame };
};
